<template>
  <div class="container faq-section my-5 py-5">
    <div class="row h-100 align-items-top">
      <div class="col-md-12">
        <h3 class="fs-38 text-center py-4">Frequently Asked Questions</h3>
      </div>
      <div class="col-md-6" v-for="(item, index ) in items">
        <div class="accordion" id="accordionExample">
          <div class="accordion-item" >
            <h2 class="accordion-header">
              <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#collapse'+ index"
                  aria-expanded="true"
                  :aria-controls="'collapse' + index"
              >
                {{ item.heading }}
              </button>
            </h2>
            <div
                :id="'collapse' + index"
                class="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
            >
              <div class="accordion-body">
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Faq",
  data() {
    return {
      items: [
        {
          heading: "How secure and private is KinFolk?",
          desc: "Yes, most Family Tree SaaS products offer secure cloud-based storage and backup options to ensure that your family tree and all its data are safe and easily accessible to you and your family members.",
        },
        {
          heading: "What if I have a large family with many generations?",
          desc: "    Yes, most Family Tree SaaS products offer secure cloud-based storage and backup options to ensure that your family tree and all its data are safe and easily accessible to you and your family members.",

        },
        {
          heading: "How do I get started with a Family Tree SaaS?",
          desc: "    Yes, most Family Tree SaaS products offer secure cloud-based storage and backup options to ensure that your family tree and all its data are safe and easily accessible to you and your family members.",

        },
        {
          heading: "Do I need any special skills to use KinFolk?",
          desc: "    Yes, most Family Tree SaaS products offer secure cloud-based storage and backup options to ensure that your family tree and all its data are safe and easily accessible to you and your family members.",

        },
        {
          heading: "Can I export my family tree data to other formats?",
          desc: "    Yes, most Family Tree SaaS products offer secure cloud-based storage and backup options to ensure that your family tree and all its data are safe and easily accessible to you and your family members.",

        },
        {
          heading: "How much does it cost to use the premium version",
          desc: "    Yes, most Family Tree SaaS products offer secure cloud-based storage and backup options to ensure that your family tree and all its data are safe and easily accessible to you and your family members.",

        },

        {
          heading: "How secure and private is AncestryDNA?",
          desc: "    Yes, most Family Tree SaaS products offer secure cloud-based storage and backup options to ensure that your family tree and all its data are safe and easily accessible to you and your family members.",

        },
        {
          heading: "How secure and private is AncestryDNA?",
          desc: "    Yes, most Family Tree SaaS products offer secure cloud-based storage and backup options to ensure that your family tree and all its data are safe and easily accessible to you and your family members.",

        },
      ],
    };
  },
};
</script>

<style>
</style>